import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { environment } from '@environments/environment';
import { appCodes } from '@core/constants/app-codes.constant';
import { CammsClientStorageService } from 'projects/camms-client-storage/src/public-api';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class TokenProcessingService {
    numberOfTokensInPool: number = 100;
    constructor(
        private storageService: CammsClientStorageService,
        private httpClient: HttpClient,
        private jwtHelper: JwtHelperService,
    ) {
        this.numberOfTokensInPool = +environment.numberOfTokensInPool;

        if(!this.numberOfTokensInPool || this.numberOfTokensInPool <= 0){
            this.numberOfTokensInPool = 100;
        }
    }

    processSecuredTokenPool(concatenatedTokenList) {
        if (
            concatenatedTokenList != null &&
            concatenatedTokenList != '' &&
            concatenatedTokenList != undefined
        ) {
            //split concatenated token list
            var splittedTokenArray = concatenatedTokenList.split(',');

            // Get queue from the local storage
            var storedQueue = [] as string[];
            var tempStoredQueue =
                JSON.parse(
                    localStorage.getItem(appCodes.auth.queuedTokenList)!,
                ) || [];

            tempStoredQueue.forEach((x) => {
                if (
                    !this.jwtHelper.isTokenExpired(
                        this.storageService.getDecryptedValue(x),
                    )
                ) {
                    storedQueue.push(x);
                }
            });

            // Tokens push to queue
            if (splittedTokenArray != null && splittedTokenArray.length > 0) {
                splittedTokenArray.forEach((item) => {
                    storedQueue = [
                        this.storageService.getEncryptedValue(item.trim()),
                        ...storedQueue,
                    ];
                });
            }

            // Remove existing tokens from the pool(keep the defined pool size)
            while (storedQueue.length > this.numberOfTokensInPool) {
                storedQueue.shift();
            }
            //Store queue in the local storage
            localStorage.setItem(
                appCodes.auth.queuedTokenList,
                JSON.stringify(storedQueue),
            );
        }
    }

    isTokenPoolThresholdReached() {
        let storedTokenQueue =
            JSON.parse(localStorage.getItem(appCodes.auth.queuedTokenList)!) ||
            [];

        let tokenPoolThreshold =
            Number(environment.tokenPoolMinimumThresholdPercentage) / 100;
        tokenPoolThreshold = tokenPoolThreshold > 0 ? tokenPoolThreshold : 0.25;
        return (
            storedTokenQueue.length <=
            tokenPoolThreshold * this.numberOfTokensInPool
        );
    }

    getAuthToken(): string[] {
        const tokenArr: string[] = [];
        // Get queue from the local storage
        const storedTokenQueue =
            JSON.parse(localStorage.getItem(appCodes.auth.queuedTokenList)!) ||
            [];
        if (storedTokenQueue.length > 0) {
            // const noOfTokens = 1;

            // for (let i = 0; i < noOfTokens; i++) {
            tokenArr.push(this.getRandomToken(storedTokenQueue));
            // }

            //Store queue in the local storage

            localStorage.setItem(
                appCodes.auth.queuedTokenList,
                JSON.stringify(storedTokenQueue),
            );
        } 
        return tokenArr;
    }

    getRandomToken(array) {
        var index = window.location.href
            .toString()
            .toLocaleLowerCase()
            .includes('other-app')
            ? 0
            : Math.floor(Math.random() * array.length);

        var item = array.splice(index, 1)[0]; // Remove the item from the array

        return this.storageService.getDecryptedValue(item);
    }

    // public get numberOfTokensInPool(): number {
    //     return Number(environment.numberOfTokensInPool);
    // }

    public storeNewToken(concatenatedTokenList) {
        const splittedTokenArray = concatenatedTokenList.split(',');

        // const token = splittedTokenArray[splittedTokenArray.length - 1];
        const token = splittedTokenArray[0];

        if (token) {
            this.setToken(token);
        }
    }

    setToken(token: string) {
        this.storageService.setData(appCodes.auth.accessToken, token);
        // localStorage.setItem('Token', token);
        this.storeLastTokenUpdatedTime();
    }

    private storeLastTokenUpdatedTime() {
        localStorage.setItem('lastAPIAt', String(Date.now()));
    }

    public tryGetRefreshTokenService(): Observable<any> {
        var tempAccessToken = this.storageService
            .getData(appCodes.auth.accessToken)
            ?.replace(/[""]/g, '')!;
        var tempRefreshToken = this.storageService
            .getData(appCodes.auth.refreshToken)
            ?.replace(/[""]/g, '')!;

        //if(!tempRefreshToken || tempRefreshToken == null)
        //window.location.reload();
        // const httpClient = new HttpClient(this.httpBackend);
        return this.httpClient.post<any>(
            environment.commonBaseUrl + '/api/v1/User/Token',
            {
                accessToken: tempAccessToken,
                refreshToken: tempRefreshToken,
                appCode: 'IRM',
            },
        );
    }

    //
    getAuthEncryptedToken(isTokenEncrypted = true): string[] {
        const tokenArr: string[] = [];
        // Get queue from the local storage
        const storedTokenQueue =
            JSON.parse(localStorage.getItem('queuedTokenList')!) || [];
        if (storedTokenQueue.length > 0) {
            const noOfTokens = 1;

            for (let i = 0; i < noOfTokens; i++) {
                tokenArr.push(
                    this.getRandomEncryptedToken(
                        storedTokenQueue,
                        isTokenEncrypted,
                    ),
                );
            }

            localStorage.setItem(
                'queuedTokenList',
                JSON.stringify(storedTokenQueue),
            );
        }
        return tokenArr;
    }

    getRandomEncryptedToken(array, isTokenEncrypted): string {
        var index = Math.floor(Math.random() * array.length);

        var item = array[index]; // Log the item
        array.splice(index, 1); // Remove the item from the array

        return isTokenEncrypted
            ? item
            : this.storageService.getDecryptedValue(item);
    }
}
